// src/services/locationService.js

export async function getUserAddressByUserId(userId) {
  // ✅ Get API Base URL from env
  const API_BASE_URL = process.env.REACT_APP_API_URL;
  
  // ✅ Using env URL
  const API_URL = `${API_BASE_URL}Customer/GetUserAddressByUserId/${userId}`;

  try {
    const res = await fetch(API_URL);

    if (!res.ok) {
      throw new Error("Failed to fetch address");
    }

    const data = await res.json();

    return data;
  } catch (error) {
    console.error("User Address API error:", error);
    throw error;
  }
}